<div *ngIf="showComponent">
    <div class="section-title">
        {{ header | translate }}
    </div>

    <div>
        <div>
            <div class="medico-concertado">
                <button ca-button (click)="showAll()">
                    Ver todos los productos
                </button>
            </div>

            <div class="cards-layout" [class.cards-layout-show-all]="isShowAllActivated">
                <div class="main-content" [class.main-content-show-all]="isShowAllActivated">
                    <div class="product-panel" *ngFor="let item of price; let i = index">
                        <div class="highlight-banner">
                            <span>
                                {{ titleObject[i]?.textoPrincipal }}
                            </span>

                            <span class="highlight-text" *ngIf="titleObject[i]?.textoSecundario">
                                {{ titleObject[i]?.textoSecundario }}
                            </span>
                        </div>

                        <div class="price-card">
                            <div class="card-main-text">
                                <div>{{ 'PYMES.PRODUCT.NO-COPAYS' | translate }}</div>

                                <div *ngIf="checkLabel(titleObject[i]?.textoPrincipal); else asterik">
                                    {{ 'PYMES.PRODUCT.NO-SHORTAGES' | translate }} *
                                </div>

                                <ng-template #asterik>
                                    <div>{{ 'PYMES.PRODUCT.NO-SHORTAGES' | translate }}</div>
                                </ng-template>
                            </div>

                            <div class="price-block">
                                <span class="price" *ngIf="price[i]; else noPrice">
                                    {{ price[i] }}
                                </span>

                                <ng-template #noPrice>
                                    <span class="price">-</span>
                                </ng-template>

                                <span class="price-details">
                                    <span class="price-suffix">{{ priceSuffix }}</span>
                                    <span class="price-insured">por asegurado</span>
                                </span>
                            </div>

                            <div class="tariff-text">
                                {{ tariffText }}
                            </div>
                        </div>

                        <div class="actions">
                            <button type="button" class="action-button" (click)="onContratar(i)">
                                {{ 'PYMES.PRODUCT.CONTRACT' | translate }}
                            </button>

                            <button type="button" class="action-button" (click)="onImprimir(i)">
                                {{ 'PYMES.PRODUCT.PRINT' | translate }}
                            </button>
                        </div>

                        <div class="product-link-wrapper">
                            <a href="javascript:void(0)" class="product-link" (click)="onConsultarInformacion(i)">
                                {{ 'PYMES.PRODUCT.PRODUCT-CHECK' | translate }}
                            </a>
                        </div>
                    </div>

                    <aside class="utility-box" *ngIf="!isShowAllActivated">
                        <h2 class="utility-title">{{ 'PYMES.INFORMATION' | translate }}</h2>

                        <ul class="utility-list">
                            <li *ngFor="let item of utilityLinks; let i = index">
                                <button type="button" (click)="handleUtilityClick(i)">
                                    {{ item }}
                                </button>
                            </li>
                        </ul>
                    </aside>
                </div>

                <div class="footnote" *ngIf="title !== 'Salud Médica Pyme' || isShowAllActivated">
                    {{ 'PYMES.FOOTER' | translate }}
                </div>

                <aside class="utility-box-all" *ngIf="isShowAllActivated">
                    <h2 class="utility-title">{{ 'PYMES.INFORMATION' | translate }}</h2>

                    <ul class="utility-list-all">
                        <li *ngFor="let item of utilityLinks; let i = index">
                            <button type="button" (click)="handleUtilityClick(i)">
                                {{ item }}
                            </button>
                        </li>
                    </ul>
                </aside>
            </div>
        </div>
    </div>
</div>